export default {
  HEADING: 'Häufige Fragen',
  HEADING_SUB: 'FAQ',
  DESCRIPTION: 'Wenn Sie zusätzliche Fragen haben, zögern Sie nicht, uns zu kontaktieren. Wir werden Ihr Anliegen umgehend bearbeiten.',
  MAIL: 'Nachricht schreiben',
};
